import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";

const Error = () => {
  return (
    <Container>
      <Alert variant="filled" severity="warning">
        נא לפנות לשירות לקוחות <br /> לא ניתן להגשת לעמוד זה
      </Alert>
    </Container>
  );
};

export default Error;